import { render } from "./NotFoundContent.vue?vue&type=template&id=56dd6bc9&scoped=true"
import script from "./NotFoundContent.vue?vue&type=script&lang=js"
export * from "./NotFoundContent.vue?vue&type=script&lang=js"

import "./NotFoundContent.vue?vue&type=style&index=0&id=56dd6bc9&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dd6bc9"]])

export default __exports__